exports.install = function(Vue, options) {
    // 函数防抖（debounce）
    // 指在时间n内，函数被触发多次，但是只执行一次，执行最新的触发。也就是在时间n内，碰到新的触发，就清除之前的，重新计时。
    let timeout = null;
    let timer = null;
    let start = 0;
    Vue.prototype.$debounce = function(func, delay) {
        if (timeout !== null) { clearTimeout(timeout) };
        timeout = setTimeout(func, delay);
    };
    //函数节流(Throttle)
    // 当持续触发某个事件时，会有规律的每隔时间n就执行一次函数。
    Vue.prototype.$throttle = function(func, wait, trailing) {
        let now = new Date();
        if ((now - start) >= wait) {
            timer && clearTimeout(timer);
            timer = null;
            start = now;
            return func()
        } else if (!timer && trailing) {
            timer = setTimeout(() => {
                timer = null;
                return func;
            }, wait)
        }
    }
};


// WEBPACK FOOTER //
// ./src/assets/js/throttleDbounce.js